import http from '../api/http';
import { API_DIA_TRABALHO_RELATORIO, API_DIAS_TRABALHO } from '../api/apiConfig';
import { createCrudService, CrudService } from './crudFactory';
import { DiaTrabalho, DiaTrabalhoCardapioReport } from '../types/producao';

export interface DiaTrabalhoService extends CrudService<DiaTrabalho> {
    relatorio: (id: number | string) => Promise<DiaTrabalhoCardapioReport>;
}

const baseService = createCrudService<DiaTrabalho>(API_DIAS_TRABALHO);

export const diaTrabalhoService: DiaTrabalhoService = {
    ...baseService,
    relatorio: (id) =>
        http
            .get<DiaTrabalhoCardapioReport>(API_DIA_TRABALHO_RELATORIO(id))
            .then((response) => response.data),
};
